/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelPrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CancelPrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const cancelPrivacyRequest = (request: CancelPrivacyRequestRequest, options?: CashRequestOptions) => post<CancelPrivacyRequestRequest, CancelPrivacyRequestResponse>("/2.0/cash/cancel-privacy-request", request, {...options, rejectOnError: true })